import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import WhatItDoes from "./components/WhatItDoes";
import HowItWorks from "./components/HowItWorks";
import AppScreenshots from "./components/AppScreenshots";
import FormatsPreview from "./components/FormatsPreview";
import Trust from "./components/Trust";
import CTASection from "./components/CTASection";
import PopularPages from "./components/PopularPages";
import Testimonials from "./components/Testimonials";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <WhatItDoes />
        <HowItWorks />
        <AppScreenshots />
        <FormatsPreview />
        <Trust />
        <CTASection />
        <PopularPages />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
}